import {transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {UUID} from 'typings/portaro.be.types';
import type {BoxStation, StationLayout, ShipmentItemInfo, Box, ViewableStationState} from './types';
import type {ActionResponse} from 'typings/portaro.be.types';


export class VerbisboxDataService {
    public static serviceName = 'verbisboxDataService';

    private static BOX_STATIONS = 'box-stations';
    private static SHIPMENTS_ROUTE = 'shipments';
    private static SERVICE_ACCESS_ROUTE = 'service-access';


    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @unRestangularize()
    public async getStations(): Promise<BoxStation[]> {
        return this.Restangular
            .all(VerbisboxDataService.BOX_STATIONS)
            .getList();
    }

    @unRestangularize()
    public async getStation(stationId: UUID): Promise<BoxStation> {
        return this.Restangular
            .one(VerbisboxDataService.BOX_STATIONS, stationId)
            .get();
    }

    @unRestangularize()
    public async getLayout(station: BoxStation): Promise<StationLayout> {
        return this.Restangular
            .one(VerbisboxDataService.BOX_STATIONS, station.id)
            .one('layout')
            .get();
    }


    @unRestangularize()
    public async getState(station: BoxStation): Promise<ViewableStationState> {
        return this.Restangular
            .one(VerbisboxDataService.BOX_STATIONS, station.id)
            .one('state')
            .get();
    }

    @unRestangularize()
    public async getShipmentItemInfos(shipmentItemsIds: UUID[]): Promise<ShipmentItemInfo[]> {
        return this.Restangular
            .all(VerbisboxDataService.SHIPMENTS_ROUTE)
            .getList({shipmentItems: shipmentItemsIds});
    }


    @unRestangularize()
    public async createServiceAccess(station: BoxStation, boxes: Box[], picking: boolean): Promise<ActionResponse> {
        return this.Restangular
            .one(VerbisboxDataService.BOX_STATIONS, station.id)
            .post(VerbisboxDataService.SERVICE_ACCESS_ROUTE, transferify({boxes, picking}));
    }
}